import React, { useState } from 'react'

import { Filter24Regular } from '@fluentui/react-icons'

import { filterButtonStyles } from './styles'

const { FilterButtonStitcherComponent } = filterButtonStyles

type StitchesButtonProps = React.ComponentProps<
	typeof FilterButtonStitcherComponent
>

interface FilterButtonProps extends StitchesButtonProps {
	children: string
	activeFilter?: boolean
	textColor?: string
	iconColor?: string
}

const FilterButton = ({
	children = 'Texto de filtro',
	activeFilter = false,
	textColor = 'white',
	iconColor,
	...props
}: FilterButtonProps) => {
	const [active] = useState(activeFilter)

	return (
		<FilterButtonStitcherComponent active={active} {...props}>
			<p style={{ color: textColor }}>{children}</p>
			<Filter24Regular color={iconColor} />
		</FilterButtonStitcherComponent>
	)
}

export { FilterButton }
